import { DVFormGroup } from './dynamic-validator';

export abstract class DVBaseAsyncValidator {
  protected _formgroup: DVFormGroup;
  protected _validatorKey: string;
  protected _message: string;
  protected _fields: Array<string>;
  protected abstract _validatorFn: (x?: any) => null | { [key: string]: boolean };

  private _hasError = false;
  constructor(vk: string) {
    this._validatorKey = vk;
  }

  apply(fg: DVFormGroup) {
    this._formgroup = fg;
    this._formgroup.setValidators(this._validatorFn);
    this._formgroup.valueChanges.subscribe(() => {
      if (this._formgroup.invalid && this._formgroup.errors && this._formgroup.errors[this._validatorKey]) {
        for (const field of this._fields) {
          this._hasError = true;
          this._formgroup.addError(field, this._validatorKey, this._message);
          // this._formgroup.forceShowErrors();
        }
      } else {
        if (this._hasError) {
          this._hasError = false;
          for (const field of this._fields) {
            this._formgroup.controls[field].updateValueAndValidity();
          }
        }
      }
    });
  }
}
